import { styled } from '@mui/material';
import { useRef, useEffect, useState } from 'react';

interface FixedContainerProps {
  children: React.ReactNode;
}

export const FixedContainer: React.FC<FixedContainerProps> = ({ children }) => {
  const fixedRef = useRef<HTMLDivElement>(null);
  const [fixedHeight, setFixedHeight] = useState<number>(0);

  useEffect(() => {
    if (fixedRef.current && fixedRef.current.offsetHeight > 0) {
      setFixedHeight(fixedRef.current.offsetHeight);
    } else {
      setFixedHeight(70);
    }
  }, [children]);

  return (
    <>
      <FixedContainerStyled ref={fixedRef}>{children}</FixedContainerStyled>
      <FixedSpacer height={fixedHeight} />
    </>
  );
};

const FixedContainerStyled = styled('div')`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: var(--mui-palette-background-main);
  z-index: 1000;
  box-shadow:
    0px -10px 15px -3px hsl(240 8% 50% / 0.15),
    0px -4px 6px -4px hsl(240 8% 50% / 0.2);

  button {
    max-width: min(200px, 50%);
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

const FixedSpacer = styled('div', { shouldForwardProp: (prop) => prop !== 'height' })<{ height: number }>`
  height: ${({ height }) => height}px;

  @media (min-width: 768px) {
    display: none;
  }
`;
